import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { ProfiliHelper } from "@app/shared/helper/profili.helper";
import { BsModalRef, BsModalService } from "ngx-bootstrap";

@Component({
  selector: "app-modale-indicazioni",
  templateUrl: "./modale-indicazioni.component.html",
})
export class ModaleIndicazioniComponent implements OnInit, OnChanges {
  @Output()
  confermaEmit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild("templateModaleIndicazioni", { static: false })
  public confermaModal: TemplateRef<any>;

  @Input()
  alert: any;

  @Input()
  isUdSerie: boolean;

  @Input()
  tipoElemento: string;

  @Input()
  stato: string;

  isRgd: boolean;

  public modalRef: BsModalRef;

  private config = {
    class: "modal-dialog modal-info modal-lg",
    animated: true,
  };
  constructor(
    private modalService: BsModalService,
    private utenteHelper: ProfiliHelper
  ) {
    this.isRgd = this.utenteHelper.isResponsabileGestioneDocumentale();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("[ModaleIndicazioniComponent][ngOnChanges]", changes);
  }

  ngOnInit() {}

  openModal() {
    console.log(
      "[ModaleConfermaComponent][emitConferma]apertura modale conferma"
    );
    this.modalRef = this.modalService.show(this.confermaModal, this.config);
  }
}
